import { User, Wallet } from "../app/app.models";
import { Subject } from "rxjs/Subject";
import { Injectable } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";
import * as firebase from "firebase";

@Injectable()
export class AuthService {
  private user: User;
  refreshWallet = new Subject();
  wallet: Wallet;
  updateUserPhoto = new Subject();

  private userfire: firebase.User;

  constructor(public afAuth: AngularFireAuth) {
    afAuth.authState.subscribe(userfire => {
      if (userfire) console.log("user ", userfire.uid, " user ", userfire);
      this.userfire = userfire;
    });
  }

  getUser() {
    return this.user;
  }

  setUser(
    uid: string,
    address: string,
    displayName: string,
    photoURL: string,
    email: string
  ) {
    this.user = {
      uid: uid,
      address: address,
      displayName: displayName,
      photoURL: photoURL,
      email: email
    };
  }

  resetPasswordWithEmial(passwordResetEmail) {
    return this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail);
  }

  signInWithEmail(credentials) {
    console.log("Sign in with email");
    return this.afAuth.auth.signInWithEmailAndPassword(
      credentials.email,
      credentials.password
    );
  }

  signUp(credentials) {
    return this.afAuth.auth.createUserWithEmailAndPassword(
      credentials.email,
      credentials.password
    );
  }

  get authenticated(): boolean {
    return this.userfire !== null;
  }

  getEmail() {
    return this.userfire && this.userfire.email;
  }

  /**signOut(): Promise<void> {
    return this.afAuth.auth.signOut();
  } */

  writeUserData(userId, name, acceptDataProtection, address, photoURL) {
    var date = new Date().toString();
    console.log("write data ");
    firebase
      .database()
      .ref("users/" + userId)
      .set({
        displayName: name,
        acceptDataProtection: acceptDataProtection,
        address: address,
        lastLogin: date,
        photoURL: photoURL,
        uid: userId
      });
  }

  readUserData(uid) {
    console.log("Read user ", uid);
    return firebase
      .database()
      .ref("/users/" + uid)
      .once("value");
  }

  readIdolData(uid) {
    console.log("Read Idol ", uid);
    return firebase
      .database()
      .ref("/prod_idols/" + uid)
      .once("value");
  }

  uploadIamges(image64: string, title: string, uid: string) {
    let storageRef = firebase.storage().ref();
    const imageRef = storageRef.child(`users/${uid}${title}.jpg`);

    return imageRef
      .putString(image64, firebase.storage.StringFormat.DATA_URL)
      .then(snapshot => {
        return snapshot.ref.getDownloadURL();
      });
  }

  updateUserProfilePhoto(url: string) {
    this.updateUserPhoto.next(url);
  }

  writeUser(user) {
    return firebase
      .database()
      .ref("users/" + user.uid)
      .set(user);
  }

  updateUserName(user, displayName) {
    return firebase
      .database()
      .ref("users/" + user.uid)
      .update({ displayName: displayName });
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.service.ts